import React from 'react'

const Icon = ({ size, fill, off }) => (
  <svg width={size} height={size} viewBox='0 0 24 24'>
    {off ? (
      <g>
        <path
          fill={fill}
          d='M15.542,12h3.657v1.801h-1.856l1.799,1.799h0.058v0.058l1.793,1.794C20.993,17.434,21,17.418,21,17.4V6.6
          c0-0.99-0.811-1.8-1.801-1.8H8.342L15.542,12z'
        />
        <path
          fill={fill}
          d='M20.004,19l-1.6-1.6h-0.001L16.603,15.6h0.001l-1.799-1.799h-0.001L13.003,12h0.001l-7.2-7.2H5.802L2.773,1.771L1.503,3.04
          l2.17,2.17C3.267,5.54,3,6.038,3,6.6v10.8c0,0.988,0.81,1.799,1.8,1.799h12.863l2.295,2.295l1.27-1.27L20.004,19
          C20.003,19,20.003,19,20.004,19z M10.2,12h0.264l1.801,1.801H10.2V12z M4.8,12h3.6v1.801H4.8V12z M13.801,17.4H4.8V15.6h9.001V17.4
          z'
        />
      </g>
    ) : (
      <path
        fill={fill}
        d='M19.199,4.8H4.8C3.81,4.8,3,5.61,3,6.6V17.4c0,0.989,0.81,1.799,1.8,1.799h14.399c0.99,0,1.801-0.81,1.801-1.799V6.6
  C21,5.61,20.189,4.8,19.199,4.8z M4.8,12H8.4v1.801H4.8V12z M13.801,17.4H4.8V15.6h9.001V17.4z M19.199,17.4h-3.6V15.6h3.6V17.4z
   M19.199,13.801H10.2V12h8.999V13.801z'
      />
    )}
  </svg>
)

Icon.defaultProps = {
  size: 24,
  fill: '#fff',
  off: false
}

export default Icon
